/*
  Add Custom JS to be layered on top of ciritical theme js
*/

// console.log('Custom js')

// Function to handle hiding offer items with matching product IDs
function hideMatchingOfferItems() {
  const cartElement = document.querySelector('[data-modal="cart"]');
  if (!cartElement) return;

  const cartItems = Array.from(cartElement.querySelectorAll('.cart-item'));
  const offerItems = Array.from(cartElement.querySelectorAll('.offer-item'));

  const cartProductIds = new Set(cartItems.map(item => item.getAttribute('data-product-id')));

  offerItems.forEach(offerItem => {
      const offerProductId = offerItem.getAttribute('data-product-id');
      if (cartProductIds.has(offerProductId)) {
          offerItem.style.display = 'none';
      } else {
          offerItem.style.display = ''; 
      }
  });
}

// Function to handle the removal of items based on the offer message
function handleOfferMessage() {
  const cartElement = document.querySelector('[data-modal="cart"]');
  if (!cartElement) return;

  const offerMessageElement = cartElement.querySelector('.cart__offer-message--success[data-product-id]');
  const offerGiftWrapperElement = cartElement.querySelector('.cart .free-gift-wrapper');
  const offerBlocks = window.Cart.blocks;

  const productIds = [];

  for (const index in offerBlocks) {
    if (offerBlocks[index].products) {
      for (const product of offerBlocks[index].products) {
        productIds.push(product.id);
      }
    }
  }

  if (offerMessageElement == null && offerGiftWrapperElement == null) {
    const cartItems = Array.from(cartElement.querySelectorAll('.cart-item'));

    cartItems.forEach(cartItem => {
      if (cartItem.getAttribute('data-free') == 'FREE') {
        const cartItemId = cartItem.getAttribute('data-product-id');

        if (productIds.includes(Number(cartItemId))) {
          const removeButton = cartItem.querySelector('.cart-item__remove');
          //console.log("Free",removeButton)
          if (removeButton) {
            removeButton.click();
          }
        }
      }
    });
  }
}

// Function to set up a MutationObserver
function setupMutationObserver() {
  const cartElement = document.querySelector('[data-modal="cart"]');
  if (!cartElement) return;

  const observer = new MutationObserver(() => {
      hideMatchingOfferItems();
      handleOfferMessage();
  });

  observer.observe(cartElement, {
      childList: true,
      subtree: true
  });
}

// Initial setup
setupMutationObserver();

// Run the functions initially in case the cart is already populated
hideMatchingOfferItems();
handleOfferMessage();






// Function to process an element and remove double quotes from its text content
function processElement(element) {
  // Recursively process all text nodes within the element
  function traverseNodes(node) {
    if (node.nodeType === Node.ELEMENT_NODE) {
      // For each child node of the element, process recursively
      node.childNodes.forEach(child => {
        traverseNodes(child);
      });
    } else if (node.nodeType === Node.TEXT_NODE) {
      // If the node is a text node, remove double quotes from its content
      node.textContent = node.textContent.replace(/"/g, '');
    }
  }

  // Start traversal from the provided element
  traverseNodes(element);
}

// Function to initialize MutationObserver on elements
function observeElements(selector) {
  // Create a MutationObserver instance
  const observernew = new MutationObserver(mutationsList => {
    mutationsList.forEach(mutation => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE && node.matches(selector)) {
            processElement(node);
          }
          // Check if any of the added nodes contain the target class
          node.nodeType === Node.ELEMENT_NODE && !!node?.querySelectorAll(selector)?.length && node.querySelectorAll(selector).forEach(targetNode => {
            processElement(targetNode);
          });
        });
      }
    });
  });

  // Start observing the document body for added nodes
  observernew.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Initial processing of existing elements
  document.querySelectorAll(selector).forEach(processElement);
}

function checkAndObserve() {
  const elements = document.querySelectorAll('.product-card__meta-promostrings');
  
  if (elements.length > 0) {
    observeElements('.product-card__meta-promostrings');
    clearInterval(intervalId); // Stop checking
  }
}

// Set up interval to check every 100 milliseconds (adjust as needed)
const intervalId = setInterval(checkAndObserve, 100);

// Optional: set up an event listener to start checking when the window is loaded
window.addEventListener('load', () => {
  checkAndObserve(); // Initial check
});


  // // search terms link and text update

  function suggestionsObserver(selector, callback) {
    const observer = new MutationObserver(() => {
      const element = document.querySelector(selector);
      const resultsDiv = document.querySelector('.search-results-direction-new');
      if (element) {
        observer.disconnect();
        callback(element);
      } else {
        if(resultsDiv){
          resultsDiv.innerHTML = '';
        }
      }
    });
  
    observer.observe(document.body, { childList: true, subtree: true });
  }

  const input = document.getElementById('modalSearchInput');

  input.addEventListener('input', function() {
    suggestionsObserver('.suggested-item a', (element) => {
      let text = element.innerHTML

      setTimeout(() => {
        const emptyQuery = document.querySelector('.empty-results-corrected-query')
        text = element.innerHTML

        if(text && emptyQuery) {
          emptyQuery.innerHTML= `Did you mean <a href="/search?q=${text}">${text}</a> ?`
        }
      }, 1500);
    });

    setTimeout(() => {
      const emptyResults = document.querySelectorAll('.instant-search-empty--title')

      if(emptyResults.length > 0){
        emptyResults.forEach(element => {
          element.innerHTML = `Your search for ${input.value} returned 0 results`
        });
      }
    }, 1500);
  })


/*   input.addEventListener('input', function() {
       const term = input.value.trim();
       const resultsDiv = document.querySelector('.search-results-direction-new');
       if (term) {
           console.log('term',term)
           if(resultsDiv){
           resultsDiv.innerHTML = `View all results for "${term}"`;
           }
       } else {
         if(resultsDiv){
           resultsDiv.innerHTML = ''; // Clear if input is empty
         }
       }
   }); */
  
   // Add a click event to redirect to the search results page
/*   document.querySelector('.search-results-direction-new').addEventListener('click', function() {
    const term = input.value.trim();
    if (term) {
        // Adjust this URL path if necessary
        const searchUrl = '/search?q=' + encodeURIComponent(term);
        console.log('search url is' + searchUrl)
        window.location.href = searchUrl;
    }
  }); */

// close search modal clicking outside the modal
const searchModal = document.querySelector('.search-results');
window.onclick = function(event) {
  console.log("event.target");
  console.log(event.target);
  if (!searchModal.contains(event.target)) {
    searchModal.classList.add('hidden');
  }
}




